<app-account-form-wrapper
  #formWrapper
  data-testid="e-invoice-account-form-wrapper"
  [config]="config()"
  [mode]="mode"
></app-account-form-wrapper>
